import { useContext } from "react"
import { CustomFormatConfig, FormattedMessage, FormattedTime } from "react-intl"
import { DateSettingsContext } from "~/containers/InitializeApp/DateSettingsProvider"

const CustomFormattedTime: React.FC<
  Intl.DateTimeFormatOptions &
    CustomFormatConfig & {
      value: string | number | Date | undefined
    }
> = props => {
  const { isHour12 } = useContext(DateSettingsContext)
  return (
    <>
      <FormattedTime hour12={isHour12} {...props} />
      &nbsp;
      {!isHour12 && <FormattedMessage id="common.oClock" />}
    </>
  )
}

export default CustomFormattedTime
